import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { find, has } from "lodash";
import { View, Group } from "../../store/students/state";

@Component({
  selector: "list-settings-sidebar",
  templateUrl: "./list-settings-sidebar.component.html",
  styleUrls: ["./list-settings-sidebar.component.scss"],
})
export class ListSettingsSidebarComponent implements OnInit, OnChanges {
  @Input() views;
  @Input() groups;
  @Input() selectedSettingsItem;
  @Output() settingsItemSelected = new EventEmitter();
  @Output() deleteViewEvent = new EventEmitter();
  @Output() deleteGroupEvent = new EventEmitter();

  selectedSettingsGroup: Group;
  selectedSettingsView: View;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change) {
    if (change && change.selectedSettingsItem) {
      if (has(this.selectedSettingsItem, "efficacyCriteria")) {
        // is group
        this.selectedSettingsGroup = this.selectedSettingsItem;
        this.selectedSettingsView = null;
      } else {
        // is view
        this.selectedSettingsView = this.selectedSettingsItem;
        this.selectedSettingsGroup = null;
      }
    }
  }

  hasOwnViews() {
    return find(this.views, ["isSharedWithMe", false]);
  }

  hasSharedWithMeViews() {
    return find(this.views, ["isSharedWithMe", true]);
  }

  hasOwnGroups() {
    return find(this.groups, ["isSharedWithMe", false]);
  }

  hasSharedWithMeGroups() {
    return find(this.groups, ["isSharedWithMe", true]);
  }
}
